module.exports = __webpack_public_path__ + "static/DotNet-d85a6bcfc03b903ca2736e8e79ede6a9.png";